import { useSelector } from 'react-redux';
import UserAvatar from './UserAvatar';
import UserInfo from './UserInfo';
import UserProfileTabs from './UserProfileTabs';
import { User, UserProfileTab } from './types';
import { AppointmentsTab, OnboardingTab } from './constant';
import { UserRoles, UserTypes } from '../../constants/UserRoles';
import './UserProfileHeader.scss';

type props = {
  userProfileDetails: User;
  onUpdateUserDetails: (updatedDetails: User) => void;
  selectedTab: string;
  userTabs: UserProfileTab[];
};

export default function UserProfileHeader({
  userProfileDetails,
  onUpdateUserDetails,
  selectedTab,
  userTabs,
}: props) {
  const { loggedInUser } = useSelector(
    ({ authentication }: any) => authentication,
  );

  // Filter out onboarding and appointment tabs if therapist-only user is viewing a client's profile
  const isTherapistOnly =
    loggedInUser?.user_type?.length === 1 &&
    loggedInUser?.user_type[0] === UserRoles.THERAPIST;

  const isViewingClient = userProfileDetails?.user_type?.includes(
    UserTypes.CLIENT,
  );

  const filteredTabs =
    isTherapistOnly && isViewingClient
      ? userTabs.filter(
          tab =>
            tab.hash !== AppointmentsTab.hash &&
            tab.hash !== OnboardingTab.hash,
        )
      : userTabs;

  return (
    <>
      {userProfileDetails && (
        <div className={`user-profile-photo-section bg-white ${isViewingClient ? 'is-client-profile' : ''}`}>
          <div className="user-content">
            <UserAvatar userProfileDetails={userProfileDetails} />
            <div className="user-details">
              <UserInfo
                userProfileDetails={userProfileDetails}
                onUpdateUserDetails={onUpdateUserDetails}
              />
              {loggedInUser?.id && (
                <UserProfileTabs
                  userProfileDetails={userProfileDetails}
                  profileTabs={filteredTabs}
                  selectedTab={selectedTab}
                />
              )}
            </div>
          </div>
        </div>
      )}
    </>
  );
}
